"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var UpgradeButton_1 = __importDefault(require("./UpgradeButton/UpgradeButton"));
var StringManipulater_1 = require("Utils/StringManipulater");
var mobx_react_1 = require("mobx-react");
var BASE_CLASS_NAME = "trial-message";
var EXPLAINER_CLASS_NAME = "".concat(BASE_CLASS_NAME, "__explainer");
var FOCUS_TEXT_CLASS_NAME = "".concat(BASE_CLASS_NAME, "__focus");
var TrialMessage = (0, mobx_react_1.observer)(function (props) {
    var upgradeButtonProps = {
        trial: props.trial,
        telemetry: props.telemetry,
        initSubscription: props.initSubscription,
    };
    if (!props.trial.isOnTrial()) {
        return null;
    }
    else if (props.trial.hasTimeLimit()) {
        var focusText = (0, StringManipulater_1.pluralise)(props.trial.daysRemaining(), "day");
        return (react_1.default.createElement("div", { className: BASE_CLASS_NAME },
            react_1.default.createElement("span", { className: EXPLAINER_CLASS_NAME },
                react_1.default.createElement("span", { className: FOCUS_TEXT_CLASS_NAME }, focusText),
                " remaining"),
            react_1.default.createElement(UpgradeButton_1.default, __assign({}, upgradeButtonProps, { origin: "time limit header" }))));
    }
    else if (props.projectLimit.hasProjectLimit()) {
        var focusText = (0, StringManipulater_1.pluralise)(props.projectLimit.getRemainingProjects(), "project");
        return (react_1.default.createElement("div", { className: BASE_CLASS_NAME },
            react_1.default.createElement("span", { className: EXPLAINER_CLASS_NAME },
                react_1.default.createElement("span", { className: FOCUS_TEXT_CLASS_NAME }, focusText),
                " remaining"),
            react_1.default.createElement(UpgradeButton_1.default, __assign({}, upgradeButtonProps, { origin: "project limit header" }))));
    }
    else if (props.projectLiveLimit.hasProjectLimit()) {
        var focusText = (0, StringManipulater_1.pluralise)(props.projectLiveLimit.getRemainingProjects(), "live project");
        return (react_1.default.createElement("div", { className: BASE_CLASS_NAME },
            react_1.default.createElement("span", { className: EXPLAINER_CLASS_NAME },
                react_1.default.createElement("span", { className: FOCUS_TEXT_CLASS_NAME }, focusText),
                " remaining"),
            react_1.default.createElement(UpgradeButton_1.default, __assign({}, upgradeButtonProps, { origin: "project limit header" }))));
    }
    else {
        return null;
    }
});
exports.default = TrialMessage;
